export default class CreateSiteViewModel {
    organisationId: string | null = null;
    id: string | null = null;
    officeName: string | null = null;
    town: string | null = null;
    region: string | null = null;
    country: string | null = null;
    postCode: string | null = null;
    adminSite: string | null = null;

    constructor(site: any = null) {
        if (site != null) {
            this.organisationId = site.organisationId;
            this.id = site.id;
            this.officeName = site.officeName;
            this.town = site.town;
            this.region = site.region;
            this.country = site.country;
            this.postCode = site.postCode;
            this.adminSite = site.adminSite;
        }
    }

}